/**
 * Overwrite one or more Uint8Array buffers with zeros in place.
 *
 * This is best-effort. JavaScript gives no memory guarantees: the JIT may
 * have copies in registers or on the stack, the garbage collector may have
 * already moved the backing buffer, and secure enclaves do not exist in
 * the browser for secp256k1 keys. Still, zeroing immediately after use
 * reduces the window during which an attacker with memory access could
 * read secrets.
 *
 * Accepts null/undefined as a convenience so callers can write
 * `zeroize(maybeKey)` without null checks.
 */
export function zeroize(...buffers) {
    for (const buf of buffers) {
        if (buf) {
            buf.fill(0);
        }
    }
}
//# sourceMappingURL=zero.js.map